// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"2435e2b7","60":"426f3f69","259":"a92c323c","261":"7c7a542f","489":"f49384b1","711":"bfce7c5f","859":"14b761e9","976":"3afc67cc"}[chunkId] + ".css";
};